import { BasicTab, ApiGeneralItem } from './type';

export const headTab = [
  { id: '4', icon: <i className="iconly-Profile icli" />, codice: 'generico',   text: 'Generico' },
  { id: '2', icon: <i className="iconly-Document icli" />, codice: 'compleanno', text: 'Compleanni' },
//   { id: '3', icon: <i className="iconly-Document icli" />, codice: 'opzione',    text: 'Opzione' },
];

export const LABELS: Record<keyof ApiGeneralItem, string> = {
  consumer_id: 'Consumer ID',
  nominativo: 'Nominativo',
  telefono: 'Telefono',
  negozio: 'Negozio',
  new_cluster_clienteling_h2_25_frh: 'New Cluster H2 25 FRH',
  generational_cluster: 'Generational Cluster',
  segm1_recency: 'Recency',
  segm1_key: 'Segm1 Key',
  behavioural_cluster: 'Behavioural Cluster',
  segm1_frequency: 'Frequency',
  segm1_monetary_regional: 'Monetary Regional',
  // mese_nascita: 'Mese nascita',
  // giorno_nascita: 'Giorno nascita',

  first_trademark_interaction_month_year: 'Primo acquisto',
  data_nascita: 'Compleanno',
  avg_age: 'Età Media',
  city: 'Città',
  last_purchase: 'Ultimo acquisto',
  preferred_rdv: 'Preferred RDV',
  desc_department: 'Dipartimento',
  rdvID: 'RDV ID',
  nota: 'Nota',
};

export const FIELD_ORDER: (keyof ApiGeneralItem)[] = [
  'consumer_id','nominativo','telefono','city', 
  'avg_age','data_nascita','negozio',
  'new_cluster_clienteling_h2_25_frh','generational_cluster','behavioural_cluster',
  'segm1_recency','segm1_frequency','segm1_monetary_regional','first_trademark_interaction_month_year','last_purchase','preferred_rdv','desc_department','segm1_key','rdvID'
];

export const EXCLUDES: Record<BasicTab, (keyof ApiGeneralItem)[]> = {
  generico: ['data_nascita','negozio','rdvID','desc_department','nota'],
  compleanno: ['preferred_rdv','segm1_monetary_regional','rdvID','desc_department','nota'],
  opzione: [],
};
